export default function TrainingFormats() {
  const formats = [
    { icon: 'ri-user-star-line', title: 'Очный тренинг', desc: 'Интенсивная работа в аудитории: практика, ролевые игры, разбор кейсов. 1-3 дня.' },
    { icon: 'ri-vidicon-line', title: 'Онлайн-обучение', desc: 'Интерактивные вебинары и воркшопы для распределённых команд с сохранением качества.' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Серия занятий с промежуточными заданиями. 4-8 недель поэтапного развития.' },
    { icon: 'ri-flashlight-line', title: 'Интенсив', desc: 'Глубокое погружение на 2-3 дня, максимальная концентрация практики и результата.' },
    { icon: 'ri-compasses-2-line', title: 'Стратегическая сессия', desc: 'Анализ текущей системы продаж, выработка стратегии и плана действий на 6-12 месяцев.' },
    { icon: 'ri-gamepad-line', title: 'Бизнес-игра', desc: 'Игровой формат для отработки навыков в условиях, приближенных к реальным ситуациям.' },
    { icon: 'ri-user-3-line', title: 'Индивидуальная работа', desc: 'Коучинг и наставничество для руководителей и ключевых менеджеров 1-на-1.' },
    { icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Долгосрочная поддержка команды: аудит, контроль KPI, корректировка программы.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Форматы обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Выберите подходящий формат. Все программы адаптируются под задачи, отрасль и уровень команды.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {formats.map((format, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${format.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{format.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{format.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}